import { render, staticRenderFns } from "./Schoolclasses.vue?vue&type=template&id=22802960"
import script from "./Schoolclasses.vue?vue&type=script&lang=js"
export * from "./Schoolclasses.vue?vue&type=script&lang=js"
import style0 from "./Schoolclasses.vue?vue&type=style&index=0&id=22802960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports